import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideTriangleAlert } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { LogoComponent } from '../../components/logo/logo.component';

/**
 * Old /join-group links. Members join a network by registering a new account through
 * its invite link, so a logged-out visitor is forwarded to the registration; an existing
 * account can't become a member.
 */
@Component({
  selector: 'app-join-group',
  standalone: true,
  imports: [RouterModule, NgIcon, HlmAlertImports, HlmButtonImports, HlmCardImports, LogoComponent],
  providers: [provideIcons({ lucideTriangleAlert })],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './join-group.component.html',
})
export class JoinGroupComponent implements OnInit {
  errorMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    const inviteToken = this.route.snapshot.queryParamMap.get('token');

    if (!inviteToken) {
      this.errorMessage = 'Ungültiger Einladungslink.';
      return;
    }
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/register'], { queryParams: { verbund_invite: inviteToken } });
      return;
    }
    this.errorMessage =
      'Mitglieder eines Netzwerks registrieren sich über diesen Link mit einem neuen Account. ' +
      'Melde dich ab und öffne den Link erneut, um dich als Mitglied zu registrieren.';
  }
}
